import { JsonObject } from 'json2typescript';
import { PortfolioanalysisCreditsInterface } from '../interfaces/portfolioanalysis-credits.interface';

@JsonObject('PortfolioanalysisCredits')
export class PortfolioanalysisCredits
  implements PortfolioanalysisCreditsInterface
{
  ApprovedAmount?: number;
  AsseType?: string;
  AsseTypeId?: string;
  AvailableBalance?: number;
  BalanceDate?: string;
  Code?: string;
  Currency?: string;
  InterestRate?: number;
  MaturityDate?: string;
  Name?: string;
  OpeningDate?: string;
  OutstandingBalance?: number;
  ProductCode?: string;
  Weight?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
